import React from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    label?: string;
    containerClassName?: string;
    variant?: 'bordered' | 'ghost';
    selectSize?: 'xs' | 'sm' | 'md' | 'lg';
    color?: 'primary' | 'secondary' | 'accent' | 'info' | 'success' | 'warning' | 'error';
    children: React.ReactNode;
}

export function Select({
    label,
    className = "",
    containerClassName = "",
    variant = 'bordered',
    selectSize,
    color,
    children,
    ...props
}: SelectProps) {
    const baseClass = "select w-full rounded-lg";

    // Variant styles (selects are bordered by default in daisyUI 5)
    let variantClass = "";
    if (variant === "bordered") variantClass = "border-base-content/20";
    else if (variant === "ghost") variantClass = "select-ghost";

    // Size styles
    let sizeClass = "";
    if (selectSize === "xs") sizeClass = "select-xs";
    else if (selectSize === "sm") sizeClass = "select-sm";
    else if (selectSize === "lg") sizeClass = "select-lg";

    // Color styles
    let colorClass = "";
    if (color === "primary") colorClass = "select-primary";
    else if (color === "secondary") colorClass = "select-secondary";
    else if (color === "accent") colorClass = "select-accent";
    else if (color === "info") colorClass = "select-info";
    else if (color === "success") colorClass = "select-success";
    else if (color === "warning") colorClass = "select-warning";
    else if (color === "error") colorClass = "select-error";

    const classes = [
        baseClass,
        variantClass,
        sizeClass,
        colorClass,
        className
    ].filter(Boolean).join(" ");

    return (
        <div className={`flex flex-col gap-1 ${containerClassName}`}>
            {label && <label className="label">{label}</label>}
            <select
                className={classes}
                {...props}
            >
                {children}
            </select>
        </div>
    );
}
